import { render, staticRenderFns } from "./caricaProdotti.vue?vue&type=template&id=f99dafbc"
import script from "./caricaProdotti.vue?vue&type=script&lang=js"
export * from "./caricaProdotti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports